// Third Party Library
import {Table} from "antd"
import { useDispatch } from "react-redux";

// Constant
import { TEMPLATE } from "../../../../../../constants";

// Handler Library 

// Redux Actions
import * as REDUX_ACTION from "../../../../../../services/redux/actions";

// Components
import {
    ButtonModal,
} from "../../../../../../components";

const { MODAL_ACTION } = TEMPLATE.MODAL;

export const ExpandTableItems = (
  columns2,
  payrollData,
  rowSelection,
  user,
  messageApi,
) => {
  const dispatch = useDispatch();

  const bulkDisbursed = () => {
    messageApi.open({
      type: "loading",
      content: "Bulk disbursed...",
      duration: 0,
    });

    dispatch(
      REDUX_ACTION.v1_payroll.bulk_disbursed_request(
        { prids: rowSelection, updatedBy: user.memid },
        () => {
          messageApi.destroy();
        }
      )
    );
  }

  return (
        <div style={{ display: "flex", flexDirection: "column" ,justifyContent: "flex-end", alignItems: "end" }}>
            <ButtonModal
              setmodal={
                MODAL_ACTION.confirmation_bulk_mark_as_disbursed_payroll
              }
              style={{
                height: "46px",
                width: "140px",
                marginBottom: "5px",
                backgroundColor: "#0E2483",
                padding: "9px 18px",
                border: "1px solid #0E2483",
                color: "white",
                outline: "#0E2483",
              }}
              onClick={() => bulkDisbursed()}
              data={rowSelection.selectedRowKeys}
              disabled={rowSelection.selectedRowKeys.length === 0}
            >
              Bulk disbursed
            </ButtonModal>
            <Table
                columns={columns2.map((c) => ({
                    ...c,
                    textWrap: "word-break",
                    ellipsis: true,
                }))}
                scroll={{x: 1700}}
                dataSource={payrollData}
                rowSelection={rowSelection}
                // loading={loadTable}
                pagination={false}
            />
        </div>
    )
};